const itemsOverflow = (array, outerWidth) => {
  let total = 0;
  let items = 0;

  while (total + array[items] <= outerWidth) {
    total += array[items];
    items += 1;
  }

  return items;
};

export default itemsOverflow;
